export default __webpack_public_path__ + "static/media/photo--lg--55.cf4018ed.jpg";